var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMypageCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.46465C1.5 4.34454 1.5 3.78449 1.71799 3.35667C1.90973 2.98034 2.21569 2.67438 2.59202 2.48264C3.01984 2.26465 3.57989 2.26465 4.7 2.26465H11.3C12.4201 2.26465 12.9802 2.26465 13.408 2.48264C13.7843 2.67438 14.0903 2.98034 14.282 3.35667C14.5 3.78449 14.5 4.34454 14.5 5.46465V5.91171C14.5 6.00917 14.421 6.08818 14.3235 6.08818H14.0896C13.0493 6.08818 12.2059 6.93155 12.2059 7.9719V7.9719C12.2059 9.0339 13.0833 9.88596 14.1449 9.85481L14.3235 9.84957C14.4201 9.84674 14.5 9.92428 14.5 10.0209V10.5352C14.5 11.6553 14.5 12.2154 14.282 12.6432C14.0903 13.0195 13.7843 13.3255 13.408 13.5172C12.9802 13.7352 12.4201 13.7352 11.3 13.7352H4.7C3.57989 13.7352 3.01984 13.7352 2.59202 13.5172C2.21569 13.3255 1.90973 13.0195 1.71799 12.6432C1.5 12.2154 1.5 11.6553 1.5 10.5352V10.0882C1.5 9.99072 1.57901 9.91171 1.67647 9.91171H1.88235C2.93819 9.91171 3.79412 9.05578 3.79412 7.99994V7.99994C3.79412 6.9441 2.93819 6.08818 1.88235 6.08818H1.67647C1.57901 6.08818 1.5 6.00917 1.5 5.91171V5.46465Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14709 2.3916V3.06868M9.14709 5.77702V6.4541M9.14709 9.16243V9.83952M9.14709 12.5479V13.2249",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMypageCoupon);
export default __webpack_public_path__ + "static/media/icon_mypage_coupon.10207c96b382d36278006063c7f3aa5e.svg";
export { ForwardRef as ReactComponent };